// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__1Ms22","menu_item":"BottomMenu_menu_item__3ucRM","menu_item_selected":"BottomMenu_menu_item_selected__2qgOw"};